import { useTranslate } from '@refinedev/core';
import { Space, Tag, Typography } from 'antd';
import { BannerSize, BannerActionKind } from '@/api/generated/schemas';
import { ratioLabel } from '@/components/user_catalog/creative/creative';

interface BannerSizeTagProps {
  value?: BannerSize | null;
  /** Appends the ratio the size stands for — space permitting. */
  showRatio?: boolean;
}

export const BannerSizeTag = ({
  value,
  showRatio = false,
}: BannerSizeTagProps) => {
  const t = useTranslate();
  if (!value) return <Tag>-</Tag>;

  const tag = (
    <Tag
      color={value === BannerSize.large ? 'blue' : 'cyan'}
      style={showRatio ? { marginInlineEnd: 0 } : undefined}
    >
      {t(`user_catalog.banner_actions.size.${value}`)}
    </Tag>
  );

  if (!showRatio) return tag;
  return (
    <Space size={4}>
      {tag}
      <Typography.Text type="secondary">{ratioLabel(value)}</Typography.Text>
    </Space>
  );
};

interface TargetAvailabilityTagProps {
  /** null — the kind takes no target; nothing to report. */
  value?: boolean | null;
}

export const TargetAvailabilityTag = ({
  value,
}: TargetAvailabilityTagProps) => {
  const t = useTranslate();
  if (value == null) return null;

  return (
    <Tag color={value ? 'success' : 'error'}>
      {t(
        `user_catalog.banner_actions.target_available.${value ? 'yes' : 'no'}`
      )}
    </Tag>
  );
};

interface BannerActionKindTagProps {
  value?: BannerActionKind | null;
}

const KIND_COLORS: Record<BannerActionKind, string> = {
  [BannerActionKind.user_profile]: 'purple',
  [BannerActionKind.shelf]: 'magenta',
  [BannerActionKind.categories]: 'cyan',
  [BannerActionKind.paywall]: 'gold',
  [BannerActionKind.book]: 'blue',
  [BannerActionKind.collection]: 'geekblue',
  [BannerActionKind.category]: 'green',
};

export const BannerActionKindTag = ({ value }: BannerActionKindTagProps) => {
  const t = useTranslate();
  if (!value) return <Tag>-</Tag>;

  return (
    <Tag color={KIND_COLORS[value]}>
      {t(`user_catalog.banner_actions.kind.${value}`)}
    </Tag>
  );
};
